/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/guid.ts" />
/// <reference path="../../../components/models/meevo.model.custom.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceContextBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";
    import SecurityParts = Meevo.Components.Common.SecurityParts;
    import IDataMaintenanceSection = Meevo.Components.BaseClasses.IDataMaintenanceSection;

    export enum PriceChangeStatusEnum {
        Active = 30552,
        Processing = 30553,
        Completed = 30554,
        Deleted = 30555
    }

    export enum PriceGroupEntityTypeEnum {
        Service = 30556,
        Product = 30557
    }

    export interface IPriceQueueItem  {
        priceGroupEntityTypeEnum: PriceGroupEntityTypeEnum,
        priceChangeStatusEnum: PriceChangeStatusEnum,
        priceGroupPriceQueueId: string,
        scheduleDate: string,
        date?: string,
        status?: string,
        type?: string,
        editable?: boolean,
    }

    export class SchedulePriceContext extends MarketPricingContext {

        initializeSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsMarketPrice = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                appSettings: this.appSettings,
                isPrimarySection: true,
                handlesOwnCrud: false,
                baseEndpoint: this.baseEndpoint,
                sectionEndpoint: '',
                loggingService: this.loggingService,
                dataService: this.dataService,
                identityService: this.identityService,
                noun: Meevo.Model.NounEnum.MarketPricing,
                $q: this.$q,
                busyService: this.busyService,
                $translate: this.$translate,
                sectionSecurityKey: '',
                usageTrackingLogFn: this.usageTrackingLog.bind(this),
                tabName: 'PRODUCTS',
                businessInfoService: this.businessInfoService
            };

            this.sections.push(
                new ProductsSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 0,
                        displayNameContentKey: 'HEADER_PRODUCTS',
                        template: 'products.html',
                        tabName: 'PRODUCTS',
                        handlesOwnCrud: this.isPriceManagement,
                        sectionSecurityKey: this.getSectionSecurityKey('PRODUCTS', SecurityParts.KEY_PART_READ),
                        noun: Meevo.Model.NounEnum.PriceManagementProducts,
                        contextService: this.contextService,
                    })
                ),

                new ServicesSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 1,
                        displayNameContentKey: 'HEADER_SERVICE',
                        template: 'services.html',
                        tabName: 'SERVICES',
                        handlesOwnCrud: this.isPriceManagement,
                        sectionSecurityKey: this.getSectionSecurityKey('SERVICES', SecurityParts.KEY_PART_READ),
                        noun: Meevo.Model.NounEnum.PriceManagementServices,
                        contextService: this.contextService,
                    })
                )
            );

            this.sections = this.sections
                .filter(section => this.securityChecker.hasSecurityDenyOrGrant(section.sectionSecurityKey));
        }

        activate(itemId: Guid, sectionContentKey?: string, asLocationIdLocal?: number, subSectionContentKey?: string) {
            let sectionKey = sectionContentKey || null;
            let sharedData = this.contextService.sharedData;

            if (sharedData && sharedData.priceQueueItem) {
                itemId = sharedData.priceQueueItem.priceGroupPriceQueueId || new Guid('00000000-0000-0000-0000-000000000000');
                switch (sharedData.priceQueueItem.priceGroupEntityTypeEnum) {
                    case PriceGroupEntityTypeEnum.Product:
                        sectionKey = 'HEADER_PRODUCTS';
                        break;
                    case PriceGroupEntityTypeEnum.Service:
                        sectionKey = 'HEADER_SERVICE';
                        break;
                }
            } else {
                this.sections.forEach((section: IDataMaintenanceSection<any>) => {
                    section.setParentItemId(undefined);
                });
            }

            // Hide sections
            this.sections.forEach((section) => {
                section.isVisible = !sectionKey || (sectionKey && section.displayNameContentKey === sectionKey);
            });

            super.activate(itemId, sectionKey, this.asLocationId);
        }

        get showEdit() {
            return this.showEditLogic() && !this.disabledPriceChange;
        }

        get disabledPriceChange() {
            let disabledPriceChange = false;
            let data = this.contextService.sharedData;
            if(data && data.priceQueueItem) {
                disabledPriceChange = data.priceQueueItem.priceChangeStatusEnum !== PriceChangeStatusEnum.Active;
            }
            return disabledPriceChange;
        }

        get requiredPriceChange() {
            return !this.disabledPriceChange && (this.selectedSection.isPreviewMassUpdate || this.canSave);
        }

        public selectSection(item: SectionParamsMarketPrice<IPagerModel>): void {
            super.selectSection(item);

            let data = this.contextService.sharedData;
            if(data && data.priceQueueItem) {
                this.pagerApplyFilter();
            }
        }

        public backToDetails(): void {
            if (this.navigationBlocked) {
                this.modalService.alert("MESSAGE_PENDING_CHANGES");
            } else {
                // Clear section data
                this.sections.forEach((section: any) => {
                    section['showFilteredItems'] = false;
                    section.clearSection();
                });
                this.selectedSection = null;
                this.contextService.setVisualState(Model.MaintenanceFormVisualState.Detail);
               (this.controller.context.selectedSection as ScheduledPriceChangeSection).applyFilter();
            }
        }

        public save (): angular.IPromise<any> {
            // scheduled required fields
            if (this.isSchedulePriceShow() && !this.selectedSection['scheduledDate']) {
                this.modalService.alert("MESSAGE_COMPLETE_ALL_FIELDS_THAT_REQUIRE_ATTENTION",
                    Components.Modal.ModalTranslationModes.Translate, true);
                return;
            }

            // Set mode Adding for use POST method API
            if(!this.itemId) {
                this.setMode(Model.MaintenanceFormState.Adding);
            }

            let message = this.$translate.instant("MESSAGE_SCHEDULE_PRICE_IRREVERCIBLE", {
                scheduledDate: moment(this.selectedSection['scheduledDate']).format('M/D/YYYY')
            });

            this.modalService.alert(message).then(() => {
                return super.save().then(() => {
                    if (!this.itemId) {
                        this.backToDetails();
                    }
                });
            });

            
        }

        public filterForScheduledDate(date: any): boolean {
            console.log(date);
            return true;
        }
    }
}
